import { render } from "./StandardHeaderProgressBar.vue?vue&type=template&id=3bff473c&scoped=true"
import script from "./StandardHeaderProgressBar.vue?vue&type=script&lang=js"
export * from "./StandardHeaderProgressBar.vue?vue&type=script&lang=js"

import "./StandardHeaderProgressBar.vue?vue&type=style&index=0&id=3bff473c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bff473c"]])

export default __exports__